import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Home = () => import('../views/HomeView.vue')
const Products = () => import('../views/ProductsView.vue')
const Detail = () => import('../views/ProductDetailView.vue')
const Auth = () => import('../views/AuthView.vue')
const Wishlist = () => import('../views/WishlistView.vue')
const Compare = () => import('../views/CompareView.vue')
const Cart = () => import('../views/CartView.vue')
const Checkout = () => import('../views/CheckoutView.vue')
const Sellers = () => import('../views/SellersView.vue')
const SellerDetail = () => import('../views/SellerDetailView.vue')
const News = () => import('../views/NewsView.vue')
const FlashDeals = () => import('../views/FlashDealsView.vue')
const Account = () => import('../views/UserCenterView.vue')
const Orders = () => import('../views/OrdersView.vue')
const OrderDetail = () => import('../views/OrderDetailView.vue')
const Tickets = () => import('../views/SupportTicketsView.vue')
const Policy = () => import('../views/PolicyView.vue')

export default new Router({
  mode: 'hash',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) return new Promise(resolve => setTimeout(() => resolve(savedPosition), 650))
    if (/^\/product\//.test(to.path) || to.path === '/productDetails') return { x: 0, y: 0 }
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', component: Home },
    { path: '/products', component: Products },
    { path: '/category/:id', component: Products, props: true },
    { path: '/product/:id', component: Detail },
    { path: '/login', component: Auth, props: { mode: 'login' } },
    { path: '/register', component: Auth, props: { mode: 'register' } },
    { path: '/wishlist', component: Wishlist, meta: { requiresAuth: true } },
    { path: '/compare', component: Compare },
    { path: '/cart', component: Cart },
    { path: '/checkout', component: Checkout, meta: { requiresAuth: true } },
    { path: '/sellers', component: Sellers },
    { path: '/seller/:id', component: SellerDetail },
    { path: '/news', component: News },
    { path: '/flash-deals', component: FlashDeals },
    { path: '/account', component: Account, meta: { requiresAuth: true } },
    { path: '/account/orders', component: Orders, meta: { requiresAuth: true } },
    { path: '/account/orders/:id', component: OrderDetail, meta: { requiresAuth: true } },
    { path: '/account/addresses', component: () => import('../views/AddressBookView.vue'), meta: { requiresAuth: true } },
    { path: '/support/tickets', component: Tickets, meta: { requiresAuth: true } },
    { path: '/seller-policy', component: Policy, meta: { policy: 'seller' } },
    { path: '/return-policy', component: Policy, meta: { policy: 'returns' } },
    { path: '/privacy-policy', component: Policy, meta: { policy: 'privacy' } },
    { path: '/terms-and-conditions', component: Policy, meta: { policy: 'terms' } },
    { path: '/policy/:type', component: Policy },
    { path: '/commodity', component: Products },
    { path: '/productDetails', component: Detail }
  ]
})
